import { Icon } from '@iconify/react'
import { Button } from 'antd'
import React, { FunctionComponent, memo, useCallback } from 'react'

import { resetDrawerView } from '../../../redux/drawerSlice'
import { useAppDispatch } from '../../../redux/hooks'

export interface AuctionDetailDrawerFooterAssigningProps {
  propertyName: string
  isAssignmentReady: boolean
  isAlreadyAssigned: boolean
  handleAssign: () => void
}

export const AuctionDetailDrawerFooterAssigning: FunctionComponent<AuctionDetailDrawerFooterAssigningProps> =
  memo(
    ({ propertyName, isAssignmentReady, isAlreadyAssigned, handleAssign }) => {
      const dispatch = useAppDispatch()

      const stopAssignmentMode = useCallback(() => {
        dispatch(resetDrawerView())
      }, [dispatch])

      return (
        <>
          <div className="flex h-full flex-col items-center justify-center text-gray-400">
            {isAssignmentReady ? (
              isAlreadyAssigned ? (
                <div className="w-4/5 flex items-center justify-center text-gray-800 text-base text-center">
                  Vybraná nemovitost je již k dražbě přiřazena
                </div>
              ) : (
                <div className="w-4/5 flex items-center justify-center text-gray-800 text-base text-center first-letter:uppercase">
                  {propertyName}
                </div>
              )
            ) : (
              <>
                <Icon icon="arcticons:cartogram" height={48} width={48} />
                <div>Vyberte nemovitost v mapě</div>
              </>
            )}
          </div>
          <div className="flex items-center justify-center space-x-2 mb-3">
            <Button type="primary" danger ghost onClick={stopAssignmentMode}>
              Vypnout přiřazování
            </Button>
            <Button
              type="primary"
              disabled={!isAssignmentReady || isAlreadyAssigned}
              onClick={handleAssign}
            >
              Přiřadit nemovitosti
            </Button>
          </div>
        </>
      )
    }
  )
